
import { OrderItem } from './order-item.model';

export interface Order {
  id?: number;
  barId?: string;
  invoiceNumber?: string;
  sessionId?: string;
  tableNumber?: string;
  customerName?: string;
  items: OrderItem[];
  status?: 'PENDING' | 'CONFIRMED' | 'PREPARING' | 'READY' | 'DELIVERED' | 'CANCELLED' | string;
  total: number;
  createdAt?: string;
  updatedAt?: string;
  notes?: string | null;
  paymentMethod?: string | null;
  // Tracked separately from status: an order can be DELIVERED and still
  // unpaid, and a cash payment is not PAID until the bar confirms it.
  paymentState?: 'UNPAID' | 'PAID' | 'FAILED' | 'REFUNDED' | string;
  staffId?: number | null;
  preparationTime?: number | null;        // minutes
  estimatedReadyTime?: string | null;
  completed?: boolean;
}
